var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocateMe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.21,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9856 7.48894C17.0041 7.42315 17.0048 7.35361 16.9875 7.28747C16.9703 7.22133 16.9357 7.16099 16.8873 7.11265C16.839 7.06432 16.7787 7.02974 16.7125 7.01247C16.6464 6.99521 16.5768 6.99588 16.5111 7.01442L7.28015 9.8135C7.20479 9.83477 7.13772 9.87853 7.08789 9.93894C7.03807 9.99936 7.00787 10.0735 7.00134 10.1516C6.99481 10.2296 7.01225 10.3078 7.05133 10.3756C7.09042 10.4435 7.14928 10.4978 7.22006 10.5313L11.3365 12.4804C11.4166 12.5184 11.4811 12.5829 11.5192 12.6631L13.4687 16.779C13.5022 16.8498 13.5565 16.9086 13.6244 16.9477C13.6922 16.9868 13.7704 17.0042 13.8484 16.9977C13.9265 16.9912 14.0006 16.961 14.0611 16.9111C14.1215 16.8613 14.1652 16.7942 14.1865 16.7189L16.9856 7.48894Z",
    stroke: "#42296E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateMe);
export default __webpack_public_path__ + "static/media/locateMe.a0b72d042339babfb193c9ea8f575157.svg";
export { ForwardRef as ReactComponent };